module.exports = __webpack_public_path__ + "img/n1-2.c2573cac.png";